import { ReferentialDto } from "api/referential";

export const INCOME_TYPES: ReferentialDto[] = [
  {
    id: '1',
    code: 'SALARY',
    label: 'Salaire',
    iconKey: 'salary'
  },
  {
    id: '2',
    code: 'FREELANCE',
    label: 'Revenus indépendant/freelance',
    iconKey: 'freelance'
  },
  {
    id: '3',
    code: 'PENSION',
    label: 'Pension de retraite',
    iconKey: 'pension'
  },
  {
    id: '4',
    code: 'UNEMPLOYMENT',
    label: 'Allocation chômage',
    iconKey: 'unemployment'
  },
  {
    id: '5',
    code: 'DISABILITY',
    label: 'Allocation handicap',
    iconKey: 'disability'
  },
  {
    id: '6',
    code: 'FAMILY_ALLOWANCE',
    label: 'Allocations familiales',
    iconKey: 'family'
  },
  {
    id: '7',
    code: 'HOUSING_ALLOWANCE',
    label: 'Aide au logement (APL/ALS/ALF)',
    iconKey: 'housing'
  },
  {
    id: '8',
    code: 'RSA',
    label: 'RSA (Revenu de Solidarité Active)',
    iconKey: 'rsa'
  },
  {
    id: '9',
    code: 'STUDENT_GRANT',
    label: 'Bourse étudiante',
    iconKey: 'student'
  },
  {
    id: '10',
    code: 'RENTAL_INCOME',
    label: 'Revenus locatifs',
    iconKey: 'rental'
  },
  {
    id: '11',
    code: 'INVESTMENT',
    label: 'Revenus de placements',
    iconKey: 'investment'
  },
  {
    id: '12',
    code: 'BUSINESS_INCOME',
    label: 'Revenus d\'entreprise',
    iconKey: 'business'
  },
  {
    id: '13',
    code: 'INTERNSHIP',
    label: 'Indemnités de stage',
    iconKey: 'internship'
  },
  {
    id: '14',
    code: 'APPRENTICESHIP',
    label: 'Salaire d\'apprentissage',
    iconKey: 'apprenticeship'
  },
  {
    id: '15',
    code: 'ALIMONY',
    label: 'Pension alimentaire',
    iconKey: 'alimony'
  },
  {
    id: '16',
    code: 'OTHER',
    label: 'Autres revenus',
    iconKey: 'other'
  }
];
